import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sanitizeUrlHost',
    standalone: true
})
export class SanitizeUrlHostPipe implements PipeTransform {

    transform(urlHost: string | null | undefined): string {
        if (!urlHost) return '';

        // Use regex to remove protocol and port
        const match = urlHost.match(/^(?:https?:\/\/)?([^:/]+)(?::\d+)?/);
        return match ? match[1] : urlHost;
    }
}
